import AiCard from "@/components/AiCard";

/** Hide blank notes and legacy `{...}` no-content JSON payloads. */
export function isValidSuggestedNote(message: unknown): message is string {
  return typeof message === "string" && message.trim().length > 0 && !message.trim().startsWith("{");
}

export function MemberInsights({ suggestedNote }: { suggestedNote?: string | null }) {
  if (!isValidSuggestedNote(suggestedNote)) {
    return null;
  }

  const feedbackUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSe21Dg7c0RZyg_AO1RdcaEYRfPMfZrPyVZZ9kirqLCayGpsoA/viewform" +
    `?usp=pp_url&entry.2050300929=${encodeURIComponent(window.location.href)}` +
    `&entry.470452171=${encodeURIComponent(suggestedNote)}`;

  return (
    <div className="mt-8 sm:mt-12">
      <AiCard text={suggestedNote} renderAsMarkdown feedbackUrl={feedbackUrl} />
    </div>
  );
}
